import validate from "/home/tickets-r2ncy/tickets.dev2.on24.nl/node_modules/nuxt/dist/pages/runtime/validate.js";
import nav_45global from "/home/tickets-r2ncy/tickets.dev2.on24.nl/client/middleware/nav.global.js";
export const globalMiddleware = [
  validate,
  nav_45global
]
export const namedMiddleware = {}